import React from "react";
import { path } from "ramda";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Stars from "react-stars";
import { colors } from "core/stylesheet";
import { insider } from "routes/paths";
import { Container } from "components/generic/layout";
import { Status, Icon } from "components/generic/kit";
import { Overlay } from "components/common/insider";
import * as model from "modules/booking/model";

const StyledLink = styled(Link)`
  color: ${colors.brand};
`;
const StyledFeedback = styled.div`
  white-space: pre-line;
`;

const Row = ({ title, value }) => (
  <div className="flex mb1">
    <div className="fw6">{title}</div>
    <div className="ml-auto">{value}</div>
  </div>
);

export default ({ call, feedback }) => {
  const query = `/?booking_id=${call.id}&target_id=${call.candidate.id}`;
  const isFeedbackCompleted = path(["data", "completed"], feedback);

  return (
    <Overlay>
      <Container>
        <div className="pv5">
          <div className="flex items-center mb3">
            <div className="fw6">Call overview</div>
            <div className="ml-auto">
              <Link className="black fw6" to={insider.insiderMain}>
                Back to my calls
              </Link>
            </div>
          </div>
          <div className="bg-white pa3 br2 f6">
            <div className="flex flex-column flex-row-ns">
              <div className="w-50-ns pr3-ns">
                <Row title="Status:" value={<Status>{call.status}</Status>} />
                <Row title="Date:" value={model.formatTime(call.date)} />
                <Row
                  title="Candidate:"
                  value={<div className="fw6">{call.candidate.full_name}</div>}
                />
                <Row title="Email:" value={call.candidate.email} />
                <Row title="Duration:" value={call.duration + " minutes"} />
                <Row
                  title="Resume"
                  value={
                    <StyledLink target="_blank" to={call.candidate.resume.url}>
                      Click to see resume
                    </StyledLink>
                  }
                />
              </div>
              <div className="w-50-ns pl3-ns">
                <div className="fw6">Objectives:</div>
                <div>{call.call_objectives}</div>
              </div>
            </div>
          </div>
          {Object.keys(call.review).length !== 0 && (
            <div>
              <div className="fw6 mb3 flex items-center mt3">
                {call.candidate.full_name} Review
              </div>
              <div className="mt2 f6 pa3 br2 bg-white">
                <div className={"mt2 pt2 bt b--moon-gray"}>
                  <div className="flex items-center f7 silver mb1">
                    <Icon className="mr1">date_range</Icon>
                    {model.formatTime(call.review.created_at)}
                  </div>
                  <div>{call.review.general_feedback}</div>
                </div>
              </div>
            </div>
          )}
          {call.status === "Settled" &&
            !isFeedbackCompleted && (
              <div className="w-100 center">
                <StyledLink
                  className="fw6 mb3 center db mt3"
                  to={insider.onCandidateFeedback + query}
                >
                  Leave a review for {call.candidate.full_name}
                </StyledLink>
              </div>
            )}
          {isFeedbackCompleted && (
            <div className="mt4">
              <div className="fw6 mb2">Your feedback:</div>
              <div className="bg-white br2 pa3">
                <Stars
                  count={5}
                  size={16}
                  value={feedback.data.rate.value}
                  edit={false}
                  color="#ffd700"
                />
                <StyledFeedback className="mt1">
                  {feedback.data.general_feedback}
                </StyledFeedback>
              </div>
            </div>
          )}
        </div>
      </Container>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/Insider/CallDetail/View.js